import { RectCategoricalLegend } from './RectCategoricalLegend.js';
import { RectRangeLegend } from './RectRangeLegend.js';
import { safeGet } from '../../../../core/utils/safe-get.js';
import { useRectData } from '../../../hooks/useRectData.js';
import type { RectSeriesWithDatapoints } from '../../../types/xy-chart-internals.js';

export function RectLegend({ series }: { series: RectSeriesWithDatapoints }) {
  const { seriesToMetadata } = useRectData();

  const { valueType } = safeGet(seriesToMetadata, series);

  if (!valueType) {
    return null;
  }

  return valueType === 'range' ? (
    <RectRangeLegend series={series} />
  ) : (
    <RectCategoricalLegend seriesId={series.id} />
  );
}
